import script from "./promoBannerSplit.vue?vue&type=script&setup=true&lang=js"
export * from "./promoBannerSplit.vue?vue&type=script&setup=true&lang=js"

import "./promoBannerSplit.vue?vue&type=style&index=0&id=d8d492ea&scoped=true&lang=css"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8d492ea"]])

export default __exports__